<template>
  <section class="order-document-info-modal" v-if="document">
    <v-btn depressed small color="error" class="mr-1 mb-1" @click="openModal" 
      v-if="canAnalyse()">      
      Recusar
    </v-btn>
    <v-btn depressed small color="success" class="mb-1" v-if="canAnalyse()"
      @click="onSubmitApprove()">
      Aprovar
    </v-btn>

    <v-dialog
      v-if="refusalModal.show"
      v-model="refusalModal.show"
      width="400"
      persistent 
      @keydown.esc="closeModal"
    > 
      <v-card class="mb-0">
        <v-card-title class="app-card-title">
          Confirmar Recusa 
          <v-spacer />
          <v-btn icon @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="app-card-content">
          <p>
            Tem certeza que deseja recusar este documento <strong>({{ document.document_type.name }})</strong>?
          </p>

          <v-form ref="form" lazy-validation>
            <v-textarea
              v-model="refusalForm.reason"
              :disabled="isLoading"
              label="Motivo da recusa*"
              :rules="[rules.required]"
              outlined
              dense
              autofocus
              placeholder="Ex:. documento vencido"
              class="mt-5"
              color="success"
            />
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            color="error"
            :disabled="isLoading"
            @click.prevent="onSubmitRefuse"
          >
            {{ isLoading ? "Processando..." : "Recusar" }}
          </v-btn>
        </v-card-actions>
      </v-card>    
    </v-dialog>
  </section>
</template>

<script>
  import DocumentService from '@/services/documento.service';

  export default {
    name: 'OrderDocumentApprovalButtons',

    props: {
      order: {
        type: Object,
        required: true
      },
      
      document: {
        type: Object,
        required: true
      },
    },  

    data: () => ({
      refusalModal: {
        show: false
      },

      refusalForm: {
        reason: null
      },

      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
      },

      isLoading: false
    }),

    methods: {
      closeModal() {
        this.refusalModal.show = false;
        this.refusalForm.reason = null;
      },

      openModal() {
        this.refusalModal.show = true;
      },

      canAnalyse() { 
        return this.order && this.order.status.raw === 'under_analysis' 
          && this.document.status.raw === 'unverified' && this.document.content.url; 
      },

      onSubmitRefuse() { 
        const isValid = this.$refs.form.validate();
        if (!isValid) return;

        this.isLoading = true;
        DocumentService.refuse(this.document.id, this.refusalForm.reason)
          .subscribe({
            next: () => {
              this.isLoading = false;
              this.$emit('updated', { updated: true });
              this.closeModal();
            },
            error: () => {
              this.isLoading = false;
            }
          });
      },

      onSubmitApprove() { 
        this.isLoading = true;
        DocumentService.approve(this.document.id)
          .subscribe({
            next: () => {
              this.isLoading = false;
              this.$emit('updated', { updated: true });
            },
            error: () => {
              this.isLoading = false;
            }
          });
      },
    },
  }
</script>